var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailMessagse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 7,
    viewBox: "0 0 23 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.93994,
    cy: 3.94434,
    r: 3,
    transform: "rotate(-90 3.93994 3.94434)",
    fill: "#B9C4E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6357,
    cy: 3.94434,
    r: 3,
    transform: "rotate(-90 11.6357 3.94434)",
    fill: "#B9C4E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3311,
    cy: 3.94434,
    r: 3,
    transform: "rotate(-90 19.3311 3.94434)",
    fill: "#B9C4E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailMessagse);
export default __webpack_public_path__ + "static/media/detail_messagse.b863466325bbd9ddceb971b264c4b596.svg";
export { ForwardRef as ReactComponent };